<app-page-header [showCustomerSpaceName]="true" [backLink]="['/customer-spaces', (customerSpace$ | async)!.id]"></app-page-header>
<h1>{{ 'contact.title' | translate }}</h1>
<div class="page">
  <div class="tiles">
    <div *ngFor="let contact of contacts$ | async" class="tile">
      <div class="name">{{ contact.firstName }} {{ contact.lastName }}</div>
      <div class="wrapper">
        <div class="image">
          <img *ngIf="contact.thumbnailPhoto" class="avatar" [src]="contact.thumbnailPhoto" width="120px" height="120px" />
          <img
            *ngIf="!contact.thumbnailPhoto"
            class="avatar"
            src="../../../assets/icons/profile_pic_empty.svg"
            width="120px"
            height="120px"
          />
        </div>
        <div class="details">
          <div class="title-org">{{ contact.isInternal ? contact.title : contact.company }}</div>
          <div class="role">{{ contact.role }}</div>
          <div class="phone">{{ contact.phoneNumber }}</div>
          <a
            class="primary-link"
            [routerLink]="['/', 'customer-spaces', (customerSpace$ | async)!.id, 'fiduciary', 'tasks', 'create']"
            [queryParams]="{ contactId: contact.id }"
            *appShowAuthorize="'APP_TASKS_WRITE'"
          >
            <span class="contact">{{ 'contact.contact' | translate }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
